module.exports = __webpack_public_path__ + "static/media/GA_wordmark_novare_Black.0ba257c7.svg";